<div class="footer">
  <img src="assets/img/footer/Ascendiun_Black-L.png" alt="Footer" class="footer-image" *ngIf="!isNewsRoute" />
  <a class="footer-link" [href]="mailText">Contact us</a>
  <a class="footer-link" routerLink="/news" *ngIf="showNewsLink">Ascendiun News</a>
  <div class="footer-media" *ngIf="isNewsRoute || showNewsLink">
    For media inquiries, please contact
    <a href="mailto:media@ascendiun.com?subject=Ascendiun%20Media%20Enquiry">media&#64;ascendiun.com</a>
  </div>
</div>

